import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import Modal from 'components/modal'
import CSSModules from 'react-css-modules'
import { VOUCHER_EDIT_MODAL } from 'constants/modal-constants'
import { hideModal } from 'actions/common'
import { getCurrentModal, getCurrentModalArgs } from 'selectors/common'
import SetupformVouchersForm from 'components/setupform-vouchers-form/setupform-vouchers-form-container'
import classnames from 'classnames'
import { editVoucher } from 'actions/setupform-voucher/setupform-voucher-actions'
import styles from '../setupform-page/setupform-page.css'

class SetupformVouchersModal extends Component {
  constructor(props) {
    super(props)

    this.handleSaveEdits = () => {
      this.formRef.submit()
    }

    this.handleCancel = () => {
      this.props.hideModal()
    }

    this.onSubmit = (values) => {
      this.props.editVoucher(
        this.props.modalArgs.setupformId,
        this.props.modalArgs.instanceGroupId,
        values
      )
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentModal !== VOUCHER_EDIT_MODAL && this.props.currentModal === VOUCHER_EDIT_MODAL) {
      // we are opening, ensure that we are scrolled to the top of the page
      setTimeout(() => {
        this.modalRef.scrollToTop()
      }, 1)
    }
  }

  render() {
    const isOpen = this.props.currentModal === VOUCHER_EDIT_MODAL

    return (
      <Modal closeModal={this.props.hideModal} isOpen={isOpen} title="Edit voucher" ref={(c) => { this.modalRef = c }}>
        {
          this.props.modalArgs &&
            <div styleName="modal-form-container">
              <SetupformVouchersForm
                onSubmit={this.onSubmit}
                ref={(c) => { this.formRef = c }}
                setupformId={this.props.modalArgs.setupformId}
                instanceGroupId={this.props.modalArgs.instanceGroupId}
              />
              <div styleName="button-container">
                <button
                  disabled={false}
                  styleName={classnames('form-button-secondary')}
                  onClick={this.handleCancel}
                >
                  Cancel
                </button>
                {" "}
                <button
                  disabled={false}
                  styleName={classnames('form-button')}
                  onClick={this.handleSaveEdits}
                >
                  Save &amp; close
                </button>
              </div>
            </div>
        }
      </Modal>
    )
  }
}

SetupformVouchersModal.propTypes = {
  currentModal: PropTypes.string,
  hideModal: PropTypes.func,
  modalArgs: PropTypes.object,
  editVoucher: PropTypes.func,
}

const mapStateToProps = state => ({
  currentModal: getCurrentModal(state),
  modalArgs: getCurrentModalArgs(state),
})

const mapDispatchToProps = { hideModal, editVoucher }

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(SetupformVouchersModal, styles))



/** WEBPACK FOOTER **
 ** ./src/containers/setupform-vouchers-page/setupform-vouchers-modal.js
 **/